/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { HttpClient, HttpErrorResponse, HttpParams, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})

export class ManageScenarioTypeListService {
  constructor(private readonly configService: ConfigService,
              private readonly http: HttpClient) {
  }

  /**
   * Get list of all Scenario Type with Index.
   */
  getList(): any {
    return this.http.get<any[]>(`${this.configService.baseApiUrl}manage-scenario-type-list`)
    .pipe(catchError(myError => this.handleError(myError)));

  }

  /**
   * Add a new Scenario Type into DB.
   * @param newValue users input.
   */
  addData(newValue: string): any {
    const params = new HttpParams().set('newValue', newValue);
    return this.http.post(`${this.configService.baseApiUrl}manage-scenario-type-list`, null, {params})
    .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * Delete a Scenario Type from DB.
   * @param value Value to delete.
   */
  deleteData(value: string): any {
    const params = new HttpParams().set('value', value);
    return this.http.delete(`${this.configService.baseApiUrl}manage-scenario-type-list`, {params})
    .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * Updated a Scenario Type.
   * @param newValue New Value to replace existing value.
   * @param oldValue existing data that will be modified.
   */
  updateData(newValue: string, oldValue: string): any {
    const params = new HttpParams().set('newValue', newValue).set('oldValue', oldValue);
    return this.http.put(`${this.configService.baseApiUrl}manage-scenario-type-list`, null, {params})
    .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * Handles the errors produced by the backend
   * @param errorResponse The error produced by the API to be handled by the frontend
   * @return void
   */
  handleError(errorResponse: HttpErrorResponse): any {
    let errorMessage = 'An unexpected error occurred';
    switch (errorResponse.status) {
      case HttpStatusCode.BadRequest: {
        if (errorResponse.error && errorResponse.error.message) {
          errorMessage = errorResponse.error.message;
        } else {
          errorMessage = 'Error getting data.';
        }
        break;
      }
    }
    return throwError(errorMessage);
  }


}
